import styled from '@emotion/styled';

const FlexCenter = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default FlexCenter;
